<template>
  <div>
    <div class="pc-chart" v-if="role == 'SuperAdmin'">
      <div class="pc-chart-header">
        <h1>
          浏览趋势
          <span v-if="dataSelected == 1">总数:{{ total }}</span>
          <span v-if="statisticArgs.pc == 2 && dataSelected == 1"
            >前一年总数:{{ total_last_year }}</span
          >
          <!-- <span>查看</span> -->
        </h1>

        <div class="device-choose" v-if="dataSelected == 1">
          <p
            :class="statisticArgs.pc == 2 ? 'choosed' : ''"
            @click="choosedevice(2)"
          >
            total
          </p>
          <p
            :class="statisticArgs.pc == 1 ? 'choosed' : ''"
            @click="choosedevice(1)"
          >
            pc
          </p>
          <p
            :class="statisticArgs.pc == 0 ? 'choosed' : ''"
            @click="choosedevice(0)"
          >
            mobile
          </p>
        </div>

        <div class="header-function">
          <!-- 时间选项卡 -->
          <div class="header-function-timeTab">
            <!-- <button
            :class="{
              active: statisticArgs.fromCurrentDate == initDate.yesterday,
            }"
            @click="changeTimeTab(initDate.yesterday)"
          >
            昨天
          </button> -->

            <button
              :class="{
                active: statisticArgs.start_time == initDate.oneWeekAgo,
              }"
              @click="changeTimeTab(initDate.oneWeekAgo)"
            >
              过去7天
            </button>
            <button
              :class="{
                active: statisticArgs.start_time == initDate.oneMonthAgo,
              }"
              @click="changeTimeTab(initDate.oneMonthAgo)"
            >
              过去30天
            </button>
            <button
              :class="{
                active: statisticArgs.start_time == initDate.firstDayThisYear,
              }"
              @click="changeTimeTab(initDate.firstDayThisYear)"
            >
              本年度
            </button>
          </div>

          <!-- 日期选择器 -->
          <el-date-picker
            class="datepicker"
            style="width: 240px; align-self: center"
            v-model="dateRangePicker"
            type="daterange"
            range-separator="至"
            :start-placeholder="$dtime(initDate.yesterday).format('YYYY-MM-DD')"
            :end-placeholder="$dtime(initDate.today).format('YYYY-MM-DD')"
            unlink-panels
            :clearable="false"
            value-format="yyyy-MM-dd"
            :default-time="['00:00:00', '23:59:59']"
            @change="selectDateRange"
          />
        </div>
        <div class="header-function">
          <div class="header-function-timeTab">
            <button
              :class="{
                active: dataSelected == 1,
              }"
              @click="changeData(1)"
            >
              浏览趋势
            </button>
            <button
              :class="{
                active: dataSelected == 2,
              }"
              @click="changeData(2)"
            >
              单页总数
            </button>
          </div>
        </div>
      </div>
      <!-- Chart 趋势图 -->
      <div
        ref="myChart"
        :style="{ width: '100%', height: '240px' }"
        v-show="dataSelected == 1"
      ></div>

      <!-- 页面总数 -->
      <div v-if="dataSelected == 2" class="single-page-data">
        <div class="page-item pc">
          <p class="title">http://wupen.org</p>
          <div class="detail-title">
            <p>链接</p>
            <p>浏览量</p>
          </div>
          <div class="detailed-item">
            <div v-for="item in pcTotal" :key="item.id" class="item-detail">
              <p>{{ "http://wupen.org" + item.link }}</p>
              <p>{{ item.value }}</p>
            </div>
          </div>
        </div>
        <div class="page-item mobile">
          <p class="title">http://mobile.wupen.org</p>
          <div class="detail-title">
            <p>链接</p>
            <p>浏览量</p>
          </div>
          <div class="detailed-item">
            <div v-for="item in mobileTotal" :key="item.id" class="item-detail">
              <p>{{ item.link }}</p>
              <p>{{ item.value }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="not_found">
      <img src="../../../../static/image/not_found.gif" />
    </div>
  </div>
</template>

<script>
import {
  getModuleStatistics_Api,
  getModulePageStatistics_Api,
} from "@/apis/statistics.api.js";
export default {
  props: { whichModule: String, config: Object },
  data() {
    return {
      dataSelected: 1,
      role: null,
      // 时间选项卡
      total: 0,
      total_last_year: 0,
      initDate: {
        today: null,
        oneWeekAgo: null,
        oneMonthAgo: null,
        firstDayThisYear: null,
      },
      // 日期选择器
      dateRangePicker: "",
      statisticArgs: {
        module: this.whichModule,
        start_time: "",
        end_time: "",
        pc: 2,
      },
      // Chart 趋势图
      xAxis: [],
      yAxis: [],
      yHistoryAxis: [],
      mobileTotal: [],
      pcTotal: [],
    };
  },
  created() {
    if (this.$global.getLocalData("role")) {
      this.role = this.$global.getLocalData("role");
    }

    this.initialDate();
    // console.log('啊啊啊啊啊啊啊啊啊啊', this.$dtime('2021-07-05T17:00:00.146Z').format('YYYY-MM-DD'))
  },
  mounted() {
    if (this.role == "SuperAdmin") {
      this.getSectionDailyStatisticses();
    }
  },
  methods: {
    changeData(data) {
      this.dataSelected = data;
      if (this.dataSelected == 1) {
        this.getSectionDailyStatisticses();
      } else {
        this.getModulePageStatistics();
      }
    },
    getModulePageStatistics() {
      getModulePageStatistics_Api(this.statisticArgs).then((res) => {
        let mobile = [];
        let pc = [];
        for (let key in res.data) {
          if (key.indexOf("mobile") != -1) {
            mobile.push({ link: key, value: res.data[key] });
          } else {
            pc.push({ link: key, value: res.data[key] });
          }
        }
        this.mobileTotal = mobile.sort((a, b) => b.value - a.value);
        this.pcTotal = pc.sort((a, b) => b.value - a.value);
        console.log(this.mobileTotal, this.pcTotal);
      });
    },
    choosedevice(device) {
      this.statisticArgs.pc = device;
      this.getSectionDailyStatisticses();
    },
    initialDate() {
      let oneDay = 1000 * 60 * 60 * 24;
      let _morn = new Date().getTime();

      this.initDate.today = this.$dtime(new Date(_morn + oneDay)).format(
        "YYYY-MM-DD"
      );

      let _diffVal = 1000 * 60 * 60 * 24 * 7;
      this.initDate.oneWeekAgo = this.$dtime(
        new Date(oneDay + _morn - _diffVal)
      ).format("YYYY-MM-DD");

      _diffVal = 1000 * 60 * 60 * 24 * 30;
      this.initDate.oneMonthAgo = this.$dtime(
        new Date(oneDay + _morn - _diffVal)
      ).format("YYYY-MM-DD");

      this.initDate.firstDayThisYear = this.$dtime(
        new Date(new Date().setMonth("0")).setDate("1")
      ).format("YYYY-MM-DD");
      console.log(this.initDate);

      this.statisticArgs.start_time = this.initDate.oneWeekAgo;
      this.statisticArgs.end_time = this.initDate.today;
    },

    getSectionDailyStatisticses() {
      getModuleStatistics_Api(this.statisticArgs).then((res) => {
        console.log(res.data);
        this.total = res.total;
        this.total_last_year = res.history_total;

        this.xAxis = [];
        this.yAxis = [];
        this.yHistoryAxis = [];

        let oneDay = 1000 * 60 * 60 * 24;
        let arr = [];
        let days =
          (new Date(this.statisticArgs.end_time).getTime() -
            new Date(this.statisticArgs.start_time).getTime()) /
          oneDay;
        for (let i = 0; i < days; i++) {
          arr.push(
            this.$dtime(
              new Date(this.statisticArgs.start_time).getTime() + oneDay * i
            ).format("YYYY-MM-DD")
          );
        }
        console.log(arr);
        this.xAxis = arr;
        for (let i = 0; i < arr.length; i++) {
          if (res.data[arr[i]]) {
            this.yAxis.push(res.data[arr[i]]);
          } else {
            this.yAxis.push(0);
          }

          let date = this.xAxis[i].split("-");

          date[0] = Number(date[0]) - 1;

          let year = date.join("-");
          console.log(year);
          if (res.history_data[year]) {
            this.yHistoryAxis.push(res.history_data[year]);
          } else {
            this.yHistoryAxis.push(0);
          }
        }
        this.drawChart();
      });
    },

    changeTimeTab(val) {
      this.dateRangePicker = [];
      this.dateRangePicker[0] = this.$dtime(val).format("YYYY-MM-DD hh:mm:ss");
      this.dateRangePicker[1] = this.$dtime(this.initDate.today).format(
        "YYYY-MM-DD hh:mm:ss"
      );
      this.statisticArgs.start_time = val;
      this.statisticArgs.end_time = this.initDate.today;
      if (this.dataSelected == 1) {
        this.getSectionDailyStatisticses();
      } else {
        this.getModulePageStatistics();
      }
    },

    selectDateRange(val) {
      let oneDay = 1000 * 60 * 60 * 24;
      this.statisticArgs.start_time = this.$dtime(new Date(val[0])).format(
        "YYYY-MM-DD"
      );
      this.statisticArgs.end_time = this.$dtime(
        new Date(val[1]).getTime() + oneDay
      ).format("YYYY-MM-DD");
      if (this.dataSelected == 1) {
        this.getSectionDailyStatisticses();
      } else {
        this.getModulePageStatistics();
      }
    },

    drawChart() {
      let myChart = this.$echarts.init(this.$refs.myChart);
      console.log(myChart);
      // 绘制图表
      myChart.setOption({
        color: ["#CAE6FF", "#FFEDC3"],
        title: {
          // text: '浏览趋势'
        },
        tooltip: {
          backgroundColor: "rgba(50,50,50,0.9)",
          trigger: "axis",
          // formatter: "{b}: {c}\n ({d}%)",
          borderColor: "transparent",
          borderWidth: "5",
          textStyle: {
            fontSize: "12",
            lineHeight: "12",
            height: "10",
            color: "white",
          },
        },
        legend: {
          data: [
            "访问量",
            `${this.statisticArgs.pc == 2 ? "前一年访问量" : null}`,
          ],
        },
        //  legend: {
        //   data: ["访问量", "历史访问量"],
        // },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        toolbox: {
          feature: {
            // 导出图片
            // saveAsImage: {},
            // 数据视图
            // dataView: {},
            // 重置
            // restore: {},
            // 区域缩放
            // dataZoom: {},
            // 动态图表类型的切换
            // magicType: {
            //   type: ['bar', 'line']
            // }
          },
        },
        xAxis: {
          type: "category",
          //  boundaryGap: false,
          data: this.xAxis,
          axisLabel: {
            showMaxLabel: true,
            //  rotate:40
          },
          boundaryGap: true,
          // data: [
          //   "0:00",
          //   "1:00",
          //   "2:00",
          //   "3:00",
          //   "4:00",
          //   "5:00",
          //   "6:00",
          //   "7:00",
          //   "8:00",
          //   "9:00",
          //   "10:00",
          //   "11:00",
          //   "12:00",
          //   "13:00",
          //   "14:00",
          //   "15:00",
          //   "16:00",
          //   "17:00",
          //   "18:00",
          //   "19:00",
          //   "20:00",
          //   "21:00",
          //   "22:00",
          //   "23:00",
          // ],
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            name: "访问量",
            // data: ["820", "932", "901", "934", "1290", "1330", "1320"],
            data: this.yAxis,
            type: "line",
            smooth: true,
            // symbol: 'none',
            itemStyle: {
              color: "#4867BC",
              width: 0,
            },

            areaStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "#CAE6FF",
                },
                {
                  offset: 1,
                  color: "#fff",
                },
              ]),
            },
          },
          {
            name: "前一年访问量",
            // data: [320, 532, 401, 234, 860, 1030, 1880, 2199],
            data: this.statisticArgs.pc == 2 ? this.yHistoryAxis : null,
            type: "line",
            smooth: true,
            // symbol: 'none',
            itemStyle: {
              color: "#F9BF56",
            },
            areaStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "#FFEDC3",
                },
                {
                  offset: 1,
                  color: "#fff",
                },
              ]),
            },
          },
        ],
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.pc-chart {
  overflow: hidden;
  min-width: 670px;
  height: 400px;
  border-radius: 4px;
  padding: 40px 15px 0 15px;
  box-shadow: $boxshadow;
  .pc-chart-header {
    position: relative;
    border-bottom: 1px solid $border-color;
    padding-bottom: 20px;
    margin-bottom: 40px;
    flex-wrap: nowrap;
    justify-content: space-between;
    .device-choose {
      position: absolute;
      top: 65px;
      left: 30px;
      display: flex;
      p {
        cursor: pointer;
        font-size: 12px;
        line-height: 20px;
        padding: 0px 10px;
        margin-right: 10px;
        border: 1px solid $timeBtn;
        border-radius: 10px;
      }
      p:hover {
        background: $timeBtn;
        color: $base-color;
      }
      .choosed {
        background: $timeBtn;
        color: $base-color;
      }
    }
    h1 {
      position: relative;
      color: $mainTitle;
      font-size: 20px;
      align-self: center;
      word-break: keep-all;
      display: inline-block;
      vertical-align: top;
      span {
        top: 65px;
        position: absolute;
        font-size: 12px;
        left: 727px;
      }
      span:nth-of-type(2) {
        position: absolute;
        font-size: 12px;
        left: 797px;
      }
      // span:nth-of-type(3) {
      //   position: absolute;
      //   font-size: 18px;
      //   top:80px;
      //   left:27px;
      // }
    }
    .header-function {
      transform: translateY(-23%);
      float: right;
      display: flex;
      /deep/ .el-radio-button__inner {
        padding: 12px 15px;
      }
      /deep/ .el-radio-group {
        margin-right: 13px;
      }
      /deep/ .el-range-separator {
        min-width: 28px;
        font-family: $chinese;
        font-size: 13.8px;
        color: $thirdTitle;
        transform: translateY(-0.5px);
      }
      /deep/ .el-input__icon.el-range__close-icon {
        display: none;
      }
      // /deep/ .el-input__icon {
      //   transform: translateX(201px) scale(1.3);
      // }
      // /deep/ .el-range-input,
      // /deep/ .el-range-separator {
      //   transform: translateX(-24px);
      // }
      .header-function-timeTab {
        font-size: 0;
        margin-right: 15px;
        border: 1px solid #dcdfe6;
        border-radius: 4px;
        height: 40px;
        overflow: hidden;
        button {
          height: 100%;
          outline: unset;
          padding: 0 14px;
          background: none;
          cursor: pointer;
          border: none;
          font-family: $chinese;
          font-size: 13.8px;
          font-weight: 400;
          color: $thirdTitle;
          &:hover {
            color: $timeBtn;
            filter: brightness(110%);
          }
          &:active {
            filter: brightness(110%);
          }
        }
        button:nth-child(1),
        button:nth-child(2),
        button:nth-child(3) {
          border-right: 1px solid #dcdfe6;
        }
        .active {
          background: #5470c6 !important;
          color: white !important;
        }
      }
    }
  }
  .single-page-data {
    display: flex;

    .page-item {
      position: relative;

      .title {
        width: 100%;
        line-height: 18px;
        font-size: 12px;
        position: absolute;
        top: -20px;
        left: 50%;
        transform: translateX(-50%);
        z-index: 10;
        color: white;
        background: $lightenYellow;
        text-align: center;
      }
      .detail-title {
        display: flex;
        p {
          // border: 1px solid black;
          line-height: 20px;
          font-size: 10px;
          text-align: center;
          color: white;
        }
        p:nth-of-type(1) {
          width: 80%;
          background: $timeBtn;
        }
        p:nth-of-type(2) {
          width: 20%;
          padding-right: 10px;
          background: $universityBorder;
        }
      }
      .detailed-item {
        overflow: auto;
        height: 240px;
        .item-detail {
          // background: red;
          display: flex;
          justify-content: space-between;
          p {
            line-height: 30px;
            font-size: 11px;
          }
          p:nth-of-type(1) {
            width: 80%;
            // @include ellipsis;
          }
          p:nth-of-type(2) {
            padding-right: 10px;
          }
        }
      }
      .detailed-item::-webkit-scrollbar-thumb:hover {
        background: $thirdTitle;
      }
      .detailed-item::-webkit-scrollbar-thumb {
        border-radius: 14px;
        background: $lightenYellow;
      }
      .detailed-item::-webkit-scrollbar {
        width: 2px;
      }
    }
    .mobile {
      width: 58%;
    }
    .pc {
      width: 38%;
      margin-right: 4%;
    }
  }
  // .datepicker {
  //   /deep/ input:focus::placeholder {
  //     color: transparent;
  //   }
  // }
}
.not_found {
  min-width: 670px;
  height: 400px;
  img {
    width: 100%;
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/componentSet/Statistical/ChartBrowseTrend.vue